import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useParams, useNavigate } from 'react-router-dom'

import TablePageHandler from '../tablePageHandler'
import Loading from '@components/loading'
import Card from '@components/card'

import colors from '@settings/styleSettings'

import { listMessages as listMessagesAction } from '@actions/notification'

import {
  Container,
  FilterContainer,
  BoldText,
  SimpleText,
  Icon,
  Option,
  Text,
  Header,
  Select,
  Row,
  Divisor,
  RowTitle,
  TextName,
  DescriptionText,
  Title,
  CardIcon,
  TitleContainer,
  Date,
  ArrowIcon,
  SeeMore,
  OriginText,
  OriginCard,
} from './styles'

import { LoadingContainer } from '../../../pages/companies/styles'

import { getDateStringFromUsableDateStrWithoutSecond } from '@util/timeUtil'

import _ from 'lodash'

const MessagesTable = ({ messages, listMessages, total }) => {
  const { companyId, programmeId, insurance } = useParams()
  const [filterState, setFilterState] = useState({
    orderByDesc: false,
    orderByAsc: true,
    sendType: 0,
    programmeId: programmeId || 0,
    companyId: companyId || 0,
  })
  const [pageSize, setPageSize] = useState(10)
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [showOrderFilterMenu, setShowOrderFilterMenu] = useState(false)
  const [showFilterMenu, setShowFilterMenu] = useState(false)
  const navigate = useNavigate()

  const goToMessage = (messageId) => {
    navigate(`/${insurance}/acompanhamento/mensagem/${messageId}`)
  }

  const getColor = (msg) => {
    if (msg.typeMessage === 'Aviso') {
      return [colors.strongYellow, colors.softYellow]
    }
    return [colors.strongGreen, colors.softGreen]
  }

  const getOriginCardColor = (msg) => {
    if (msg.companyName || msg.programmeName) {
      return [colors.strongBlue, colors.softBlue]
    }
    return [colors.strongGreen, colors.softGreen]
  }

  const orderOptions = [
    {
      label: 'Mais recente-Mais antigo',
      value: 'desc',
      isActive: filterState.orderByDesc,
    },
    {
      label: 'Mais antigo-Mais recente',
      value: 'asc',
      isActive: filterState.orderByAsc,
    },
  ]

  const showOptions = [
    {
      label: 'Todos',
      value: 'allMessages',
      isActive: filterState.sendType === 0,
    },
    {
      label: 'Programas',
      value: 'onlyProgram',
      isActive: filterState.sendType === 1,
    },
    {
      label: 'Empresas',
      value: 'onlyCompany',
      isActive: filterState.sendType === 2,
    },
  ]

  useEffect(() => {
    setLoading(true)
    listMessages(
      {
        ...filterState,
        page,
        pageSize,
      },
      () => setLoading(false)
    )
  }, [page, pageSize, filterState])

  const handleOrderChange = (order) => {
    if (order === 'desc') {
      setFilterState({
        ...filterState,
        orderByDesc: true,
        orderByAsc: false,
      })
    } else if (order === 'asc') {
      setFilterState({
        ...filterState,
        orderByDesc: false,
        orderByAsc: true,
      })
    } else if (order === 'allMessages') {
      setFilterState({
        ...filterState,
        sendType: 0,
      })
    } else if (order === 'onlyProgram') {
      setFilterState({
        ...filterState,
        sendType: 1,
      })
    } else if (order === 'onlyCompany') {
      setFilterState({
        ...filterState,
        sendType: 2,
      })
    }
    setShowFilterMenu(false)
    setShowOrderFilterMenu(false)
  }

  const row = (message) => {
    return (
      <Row key={message.id}>
        <RowTitle>
          <CardIcon color={getColor(message)}>
            <span className="material-symbols-outlined">mail</span>
          </CardIcon>
          <TitleContainer>
            <Title>{message.typeMessage}</Title>
            <Date>
              {message
              && getDateStringFromUsableDateStrWithoutSecond(message.sentAt)}
            </Date>
          </TitleContainer>
        </RowTitle>
        <Divisor />
        <TextName>{`Enviado por ${message.senderName}`}</TextName>
        <Divisor />
        <DescriptionText>
          {`Enviado para ${message.global ? 'todos os' : message.totalBeneficiaries} beneficiários`}
        </DescriptionText>
        <Divisor />
        <OriginCard color={getOriginCardColor(message)}>
          <OriginText>
            {message?.companyName || message?.programmeName
              ? message.companyName || message.programmeName
              : 'Geral'}
          </OriginText>
        </OriginCard>
        <Divisor />
        <SeeMore onClick={() => goToMessage(message.id)}>
          Ver mais
          <ArrowIcon>
            <span className="material-icons-outlined">chevron_right</span>
          </ArrowIcon>
        </SeeMore>
      </Row>
    )
  }

  const renderFilter = (simpleText, options, showmenu, setShowMenu) => {
    return (
      <Select showmenu={showmenu} onClick={() => setShowMenu(!showmenu)}>
        <FilterContainer>
          <Text>
            <SimpleText>{simpleText}</SimpleText>
            {_.map(options, (option, index) => (
              <Option key={index}>
                {option.isActive && (
                  <>
                    <BoldText>{option.label}</BoldText>
                    <Icon>
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: '16px' }}
                      >
                        {`expand_${showmenu ? 'less' : 'more'}`}
                      </span>
                    </Icon>
                  </>
                )}
              </Option>
            ))}
          </Text>
        </FilterContainer>
        {_.map(options, (option, index) => (
          <Text key={index}>
            <Option
              onClick={() => handleOrderChange(option.value)}
            >
              {showmenu && !option.isActive && (
                <BoldText>{option.label}</BoldText>
              )}
            </Option>
          </Text>
        ))}
      </Select>
    )
  }

  return (
    <Container>
      <Card
        style={{
          borderRadius: 10,
          boxShadow: 'none',
          marginTop: '5px',
          marginBottom: '0px',
          width: '100%',
          padding: '0px',
          gap: '0px',
        }}
      >
        <Header>
          {renderFilter(
            'Ordenar por: ',
            orderOptions,
            showOrderFilterMenu,
            setShowOrderFilterMenu
          )}
          {(!companyId && !programmeId) && renderFilter(
            'Exibir: ',
            showOptions,
            showFilterMenu,
            setShowFilterMenu
          )}
        </Header>
        {loading ? (
          <LoadingContainer>
            <Loading color={colors.strongGreen} height={30} width={30} />
          </LoadingContainer>
        ) : (
          messages && _.map(messages, (m) => row(m))
        )}
        <TablePageHandler
          sizeOnPage={messages && messages?.length}
          page={page + 1}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
        />
      </Card>
    </Container>
  )
}

MessagesTable.propTypes = {
  messages: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  listMessages: PropTypes.func.isRequired,
}

const mapStateToProps = ({ notification }) => ({
  messages: notification.messages,
  total: notification.total,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    listMessages: listMessagesAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(MessagesTable)
